import React from "react";
import { IAddBanner, IBannerId } from "../../Banner.props";
import { useForm } from "react-hook-form";
import { CancelButton, FormButton } from "../../../../components/Botton";
import Loader from "../../../../components/Loader";
import useEditBanner from "./useEditBanner";

const EditBanner: React.FC<IBannerId> = ({ bannerId }) => {
  const { formData, loading, handleChange, handleSubmit, handleCancel } =
    useEditBanner(bannerId);
  const {
    register,
    handleSubmit: useFormSubmit,
    formState: { errors },
  } = useForm<IAddBanner>();

  const fields = [
    { label: "image", name: "image", type: "file" },
    { label: "link", name: "link", type: "text" },
  ] as const;

  return (
    <div className="flex flex-col items-center w-full h-screen p-8">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-gray-700 ml-5">Edit Banner</h1>
        </div>
        {loading && <Loader />}
        <form onSubmit={useFormSubmit(handleSubmit)} className="space-y-6">
          <fieldset className="m-2 rounded border-opacity-60 bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              {fields.map((field) => (
                <div key={field.name}>
                  <label
                    className="block text-gray-700 text-base font-semibold mb-2"
                    htmlFor={field.name}
                  >
                    {field.label}:
                  </label>
                  {field.type === "file" ? (
                    <>
                      <input
                        className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                        type={field.type}
                        id={field.name}
                        {...register(field.name, { required: false })}
                        onChange={handleChange}
                      />
                      {formData.image && typeof formData.image === "string" && (
                        <img
                          src={formData.image}
                          alt="Current banner"
                          className="mb-4 mt-2 h-32 w-full object-cover rounded"
                        />
                      )}
                    </>
                  ) : (
                    <input
                      className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                      type={field.type}
                      id={field.name}
                      value={formData.link || ""}
                      {...register(field.name, { required: false })}
                      onChange={handleChange}
                      placeholder={
                        field.name === "link"
                          ? "https://example.com?param1=value1&param2=value2"
                          : ""
                      }
                    />
                  )}
                  {field.name === "link" && (
                    <p className="text-xs text-gray-500 mt-1">
                      Enter a URL with parameters if needed
                    </p>
                  )}
                  {errors.image && field.name === "image" && (
                    <span className="text-red-500 text-xs italic">
                      {field.label} field is required
                    </span>
                  )}
                </div>
              ))}
            </div>
          </fieldset>
          <div className="flex justify-start mt-6 ml-10">
            <FormButton className="py-2 px-4 rounded mr-4" type="submit">
              Update
            </FormButton>
            <CancelButton
              className="py-2 px-4 rounded"
              onClick={handleCancel}
              type="button"
            >
              Cancel
            </CancelButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditBanner;
